<template>
  <div class="section">
    <div class="container">
      <h1>User groups</h1>
      <div class="columns">
        <div class="column is-3">
          <b-input v-model="filter" placeholder="Filter Groups"></b-input>
        </div>
        <div class="column is-9">
          <b-button class="is-primary is-pulled-right" @click="openAddGroupsModal({})">Add Group</b-button>
        </div>
      </div>
      <b-table :data="filterGroups"
               :hoverable="true"
               :loading="isLoading"
               :mobile-cards="true"
               :paginated="true"
               :per-page="10"
               :pagination-simple="true"
               default-sort-direction="asce"
               default-sort="Name">
        <b-table-column field="Name" label="Name" sortable v-slot="props">
          <a @click="openAddGroupsModal(props.row)">{{ props.row.Name }}</a>
        </b-table-column>
        <b-table-column field="Type" label="Type" v-slot="props">
          {{ props.row.Type }}
        </b-table-column>
        <b-table-column label="Manage Users" v-slot="props">
          <div @click="goToManageUsers(props.row.Name)">
            <i class="fad fa-users pointer-cursor yellow"></i>
          </div>
        </b-table-column>
        <b-table-column label="Send Email" v-slot="props">
          <div @click="openSendEmail(props.row)">
            <i class="fad fa-envelope pointer-cursor"></i>
          </div>
        </b-table-column>
      </b-table>
    </div>
  </div>
</template>

<script>
  import addGroupsModal from "@/components/modals/addGroups.vue";
  import sendGroupMessage from "@/components/modals/sendGroupMessage.vue";
  export default {
    name: 'groupsAdmin',
    data() {
      return {
        groups: [],
        columns: [],
        filter: '',
        isLoading: false,
        filteredGroups: [],
        options: []
      }
    },
    computed: {
      filterGroups() {
        return this.groups.filter((option) => {
          if (option.Name.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return option
              .Name
              .toString()
              .toLowerCase()
              .indexOf(this.filter.toLowerCase()) >= 0;
          } else if (option.Type.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return option
              .Type
              .toString()
              .toLowerCase()
              .indexOf(this.filter.toLowerCase()) >= 0;
          }
        });
      }
    },

    methods: {
      goToManageUsers(name) {
        this.$router.push({ name: 'userAdmin', params: { group: name } });
      },
      getGroups() {
        this.isLoading = true;
        this.$http.get("api/group/manager")
          .then(resp => {
            this.groups = resp.data;
            this.isLoading = false;
          }).catch(err => {
            console.error(err);
            this.isLoading = false;
          });
      },
      openAddGroupsModal(model) {
        this.$buefy.modal.open({
          parent: this,
          component: addGroupsModal,
          hasModalCard: true,
          props: {
            Model: model
          },
          events: {
            addGroup: (group) => {
              this.$http.post("api/group", group)
                .then(async resp => {
                  if (resp.data) {
                    this.$buefy.notification.open({
                      duration: 4000,
                      message: "Group added successfully",
                      type: 'is-success',
                    })
                  } else {
                    this.$buefy.notification.open({
                      duration: 4000,
                      message: "An error occured. Please try again later.",
                      type: 'is-danger',
                    })
                  }
                  await this.getGroups()
                }).catch(async err => {
                  await this.getGroups()
                })
            },
            editGroup: (group) => {
              this.$http.post("api/group/edit", group)
                .then(async resp => {
                  if (resp.data) {
                    this.$buefy.notification.open({
                      duration: 4000,
                      message: "Group edited successfully",
                      type: 'is-success',
                    })
                  } else {
                    this.$buefy.notification.open({
                      duration: 4000,
                      message: "An error occured. Please try again later.",
                      type: 'is-danger',
                    })
                  }
                  await this.getGroups()
                }).catch(async err => {
                  await this.getGroups()
                })

            }
          }
        })
      },
      openSendEmail(group) {
        this.$buefy.modal.open({
          parent: this,
          component: sendGroupMessage,
          hasModalCard: true,
          props: {
            CC: this.options,
            To: group.Users,
            Group: group
          },
          events: {
            sendGroupEmail: (email) => {
              this.$http.post("api/group/email", email)
                .then(resp => {
                  if (resp.data == "Message sent.") {
                    this.$buefy.notification.open({
                      duration: 4000,
                      message: "Your email has been sent.",
                      type: 'is-success',
                    })
                  } else {
                    this.$buefy.notification.open({
                      duration: 4000,
                      message: "An error occured. Please try again later.",
                      type: 'is-danger',
                    })
                  }
                })
              this.getGroups();
            }
          }
        })
      }
    },
    created() {
      this.isLoading = true;
      this.getGroups();

      this.$http.get("api/group/ccOptions")
        .then(resp => {
          this.options = resp.data;
          this.isLoading = false;
        }).catch(err => {
          console.error(err);
          this.isLoading = false;
        });
    },
  }
</script>

<style>
  .pointer-cursor {
    cursor: pointer;
  }
</style>
